<template>
  <el-carousel
    :interval="3000"
    :type="carouselType"
    :height="carouselHeight"
    indicator-position="outside"
    pause-on-hover
  >
    <el-carousel-item v-for="item in items" :key="item" :label="item.desc">
      <img
        :src="item.src"
        style="width: 100%; height: 100%; object-fit: cover"
        :alt="item.desc"
      />
    </el-carousel-item>
  </el-carousel>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";

const items = [
  {
    src: require("../assets/Showcase/family.jpg"),
    desc: "家人",
  },
  {
    src: require("../assets/Showcase/故乡关帝庙.jpg"),
    desc: "运城关帝庙",
  },
  {
    src: require("../assets/Showcase/故乡.jpg"),
    desc: "故乡",
  },
  {
    src: require("../assets/Showcase/康杰纪念馆.jpg"),
    desc: "康杰纪念馆",
  },
  {
    src: require("../assets/Showcase/祖宅.jpg"),
    desc: "祖宅",
  },
  {
    src: require("../assets/Showcase/伦敦2.jpg"),
    desc: "伦敦街头",
  },
  {
    src: require("../assets/Showcase/福尔摩斯博物馆.jpg"),
    desc: "福尔摩斯博物馆",
  },
  {
    src: require("../assets/Showcase/约克.jpg"),
    desc: "约克大教堂",
  },
  {
    src: require("../assets/Showcase/mcm2207862.png"),
    desc: "美赛",
  },
  {
    src: require("../assets/Showcase/舞台剧.jpeg"),
    desc: "同舟共济舞台剧",
  },
  {
    src: require("../assets/Showcase/学生会.jpg"),
    desc: "学生会",
  },
  {
    src: require("../assets/Showcase/四平校区.jpg"),
    desc: "四平校区",
  },
  {
    src: require("../assets/Showcase/济樱.jpg"),
    desc: "四平校区",
  },
  {
    src: require("../assets/Showcase/campus.jpg"),
    desc: "嘉定校区",
  },
  {
    src: require("../assets/Showcase/俄罗斯国家芭蕾舞团1.jpg"),
    desc: "俄罗斯国家芭蕾舞团",
  },
  {
    src: require("../assets/Showcase/俄罗斯国家芭蕾舞团.jpg"),
    desc: "俄罗斯国家芭蕾舞团",
  },
  {
    src: require("../assets/Showcase/上美影.jpg"),
    desc: "上美影",
  },
  {
    src: require("../assets/Showcase/苏州园林.jpg"),
    desc: "苏州园林",
  },
  {
    src: require("../assets/Showcase/volunteer.png"),
    desc: "志愿者",
  },
  {
    src: require("../assets/Showcase/西湖1.jpg"),
    desc: "西湖",
  },
  {
    src: require("../assets/Showcase/西湖2.jpg"),
    desc: "西湖",
  },
  {
    src: require("../assets/Showcase/hk.jpg"),
    desc: "香港红帆游艇",
  },
  {
    src: require("../assets/Showcase/hkust.jpg"),
    desc: "科大海景",
  },
  {
    src: require("../assets/Showcase/VictorianLabour.jpg"),
    desc: "维多利亚港",
  },
];
const carouselHeight = ref("50vh");
const carouselType = ref("card");

const updateCarouselHeight = () => {
  if (window.innerWidth <= 768) {
    carouselHeight.value = "30vh";
    carouselType.value = "";
  } else {
    carouselHeight.value = "50vh";
    carouselType.value = "card";
  }
};
onMounted(() => {
  updateCarouselHeight();
  window.addEventListener("resize", updateCarouselHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateCarouselHeight);
});
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 24px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
